export const getCdnAttributeColor = (color: string) => {
    if (!color) {
        return;
    }
    return `https://cdn-v2.kidsplaza.vn/media/attribute/swatch/swatch_thumb/110x90/${color}`;
};

export const convertPathToImageUrl = (path: string) => {
    return `https://cdn-v2.kidsplaza.vn/${path}`;
};

export const getBannerUrlByPath = (path: string): string => {
    return `https://cdn-v2.kidsplaza.vn/media/mageplaza/bannerslider/banner/image/${path}`;
};

export const getCategoryImageUrlByPath = (path: string): string => {
    if (path?.includes('/media/catalog/category/')) {
        return `https://cdn-v2.kidsplaza.vn/${path}`;
    }
    return `https://cdn-v2.kidsplaza.vn/media/catalog/category/${path}`;
};

export const getDefaultImageHorizontal = () => {
    return 'https://cdn-v2.kidsplaza.vn/media/gallery/image/kidsplaza_share_image.jpg';
};
